import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaceHappy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 729,
	height: 727,
	viewBox: "0 0 729 727",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3802_6302)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M728.69 344.84C728.69 147.48 584.88 0 385.02 0C282.2 0 194.23 39.32 133.02 104.22C189.94 61.62 262.13 36.9 343.66 36.9C543.52 36.9 687.33 184.38 687.33 381.74C687.33 477.05 653.419 561.1 595.659 622.35C678.269 560.53 728.69 461.05 728.69 344.84Z",
					fill: "#FFA6DD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.35 344.84C41.35 249.53 75.26 165.48 133.02 104.23C50.42 166.05 0 265.52 0 381.73C0 578.02 143.81 726.57 343.67 726.57C446.49 726.57 534.47 687.25 595.67 622.35C538.75 664.95 466.56 689.67 385.03 689.67C185.17 689.67 41.36 541.13 41.36 344.83L41.35 344.84Z",
					fill: "#D900D6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M343.67 36.9004C262.14 36.9004 189.95 61.6304 133.03 104.22C75.2704 165.48 41.3604 249.52 41.3604 344.83C41.3604 541.12 185.17 689.67 385.03 689.67C466.56 689.67 538.76 664.94 595.67 622.35C653.43 561.09 687.34 477.05 687.34 381.74C687.34 184.39 543.53 36.9004 343.67 36.9004Z",
					fill: "#FF5FA2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M397.996 297.954C397.996 328.665 370.914 352.229 336.294 351.671C307.035 351.224 285.425 329.615 286.263 301.751C287.156 272.492 315.355 247.979 348.914 247.197C376.554 246.583 397.996 268.751 397.996 297.954Z",
					fill: "#4D122C"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 327.959,
					cy: 287.348,
					rx: 23.8352,
					ry: 29.115,
					transform: "rotate(21.8266 327.959 287.348)",
					fill: "#FCFCF7"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 364.524,
					cy: 315.855,
					rx: 10.1901,
					ry: 12.4473,
					transform: "rotate(21.8266 364.524 315.855)",
					fill: "#FCFCF7"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M631.276 297.954C631.276 328.665 604.194 352.229 569.574 351.671C540.315 351.224 518.705 329.615 519.543 301.751C520.436 272.492 548.635 247.979 582.194 247.197C609.834 246.583 631.276 268.751 631.276 297.954Z",
					fill: "#4D122C"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 561.239,
					cy: 287.348,
					rx: 23.8352,
					ry: 29.115,
					transform: "rotate(21.8266 561.239 287.348)",
					fill: "#FCFCF7"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 597.803,
					cy: 315.855,
					rx: 10.1901,
					ry: 12.4473,
					transform: "rotate(21.8266 597.803 315.855)",
					fill: "#FCFCF7"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M423.298 343.967C421.207 341.954 418.459 340.66 415.523 340.49C412.588 340.319 409.725 341.267 407.534 343.152C405.342 345.037 403.977 347.727 403.707 350.654C403.437 353.583 404.305 356.492 405.983 358.861C407.224 360.564 408.475 362.171 409.852 363.797C421.758 378.229 441.205 389.51 462.268 389.136C483.343 389.053 502.142 377.674 513.95 363.469C515.31 361.864 516.547 360.278 517.776 358.598C519.331 356.404 520.184 353.72 519.992 350.997C519.802 348.275 518.603 345.755 516.625 343.96C514.648 342.165 512.023 341.215 509.296 341.289C506.566 341.362 503.978 342.47 501.944 344.23C500.675 345.302 499.437 346.286 498.144 347.273C486.648 356.048 474.152 361.109 462.021 361.169C449.893 361.334 437.685 356.254 426.86 347.13C425.642 346.106 424.483 345.082 423.298 343.967Z",
			fill: "#4D122C"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3802_6302",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 728.69,
				height: 726.57,
				fill: "white"
			})
		}) })
	]
});
export default SvgFaceHappy;
